import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { getStorage } from '@/lib/state/ssr-storage';

type ColorMode = 'light' | 'dark' | 'system';

interface ThemeState {
  colorMode: ColorMode;
  isDark: boolean;
  setColorMode: (mode: ColorMode) => void;
  toggleDarkMode: () => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      colorMode: 'light',
      isDark: false,
      setColorMode: (mode) => {
        const isDark = mode === 'dark';
        set({ colorMode: mode, isDark });
      },
      toggleDarkMode: () => {
        const current = get().isDark;
        set({ colorMode: current ? 'light' : 'dark', isDark: !current });
      },
    }),
    {
      name: 'inverio-theme',
      storage: createJSONStorage(getStorage),
    }
  )
);
